import { createFileRoute, redirect, } from '@tanstack/react-router';
export const Route = createFileRoute('/suche')({
    validateSearch: search => ({
        postcode: typeof search.postcode === 'string' ? search.postcode : undefined,
    }),
    beforeLoad: ({ search }) => {
        throw redirect({
            to: '/search/psychotherapists-in-{-$cityslug}',
            params: {
                cityslug: search.postcode,
            },
            replace: true,
        });
    },
});
//# sourceMappingURL=suche.js.map